import axiosClient from "./axiosClient";

// API toggle luồng mua TikTok (showcase trưng bày cũ ↔ link RioHub).
// App & web đọc file tĩnh /img/tiktok-affiliate-config.json; admin sửa qua endpoint này.
const tiktokAffiliateConfigApi = {
    getConfig() {
        return axiosClient.get("tiktok-affiliate-config");
    },
    updateConfig(payload) {
        return axiosClient.put("tiktok-affiliate-config", payload);
    },
};

export default tiktokAffiliateConfigApi;
